
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/contactus",
      function () {
        return require("private-next-pages/[lang]/contactus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/contactus"])
      });
    }
  